import { render, staticRenderFns } from "./ObservationForm.vue?vue&type=template&id=7fdc936e&"
import script from "./ObservationForm.vue?vue&type=script&lang=js&"
export * from "./ObservationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports